var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4997 74.4167C23.4997 78.725 27.0247 82.25 31.333 82.25H62.6663C66.9747 82.25 70.4997 78.725 70.4997 74.4167V27.4167H23.4997V74.4167ZM74.4163 15.6667H60.708L56.7913 11.75H37.208L33.2913 15.6667H19.583V23.5H74.4163V15.6667Z",
    fill: "url(#paint0_linear_2039_617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2039_617",
    x1: 74.6846,
    y1: 11.589,
    x2: 3.84439,
    y2: 127.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5292D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5e2c46d74e73e033370f8fa84c5c738e.svg";
export { ForwardRef as ReactComponent };